<template>
  <el-row>
    <el-form :model="setBusinessIntranetExtendForm"
             ref="setBusinessIntranetExtendRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             addAction="businessIntranet/updateBusinessExtInfo.action"
             editAction="businessIntranet/updateBusinessExtInfo.action"
             selectAction="businessIntranet/selectBusinessExtInfo.action"
             label-width="150px"
             style="width:50%"
             v-form>
      <el-form-item>
        <el-select v-model="setBusinessIntranetExtendForm.levelType" placeholder="用户等级"
                 >
          <el-option :value="'高'" label="高"></el-option>
          <el-option :value="'中'" label="中"></el-option>
          <el-option :value="'低'" label="低"></el-option>
          <el-option :value="'无意向'" label="无意向"></el-option>
          <el-option :value="'未知'" label="未知"></el-option>
          <el-option :value="'非车商'" label="非车商"></el-option>
          <el-option :value="'已注销'" label="已注销"></el-option>
          <el-option :value="'代理'" label="代理"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'

export default {
  name: 'setBusinessIntranetExtend',
  extends: BasicPager,
  components: {},
  data: function () {
    return {
      rules: {},
      setBusinessIntranetExtendForm: {
        id: null,
        levelType: null
      }
    }
  },
  created () {
    this.setBusinessIntranetExtendForm.id = this.$route.query.businessId
  },
  methods: {
    onFilterParams: function (params) {

    },
    onSelectInfo: function (dataInfo) {
    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
